export default {
    global: {
        /** Hex: #000000 */
        black: '#000000',
        /** Hex: #ffffff */
        white: '#ffffff',
        /** Hex: #E7E6E7 */
        separator: '#E7E6E7'
    },
    accent: {
        /** Hex: #939596 */
        primary: '#939596',
        /** Hex: #747371 */
        secondary: '#747371',
    },
    highlight: {
        /** Hex: #E7E6E7 */
        primary: '#E7E6E7',
        /** Hex: #F9F9F9 */
        secondary: '#F9F9F9',
        menu: '#E3EFDE',
        topLink: '#939596',
    },
    validation: {
        /** Hex: #7BBA5C */
        valid: '#7BBA5C',
        /** Hex: #D02D2D */
        invalid: '#D02D2D',
    },
};
